import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Editor from './editor';
import Player from './player';
import Sequencer from './sequencer';
import Home from './home';
import Raw from './raw';
import Dashboard from './dashboard';
import './style.css';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/_tools">
          <Home />
        </Route>
        <Route exact path="/_tools/editor">
          <Editor />
        </Route>
        <Route exact path="/_tools/sequencer/:project" children={<Sequencer />} />
        <Route exact path="/_tools/raw/:project" children={<Raw />} />
        <Route exact path="/_dashboard/:project" children={<Dashboard />} />
        <Route exact path="/p/:project" children={<Player />} />
        <Route exact path="/"></Route>
      </Switch>
    </Router>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// if (import.meta.hot) {
//   import.meta.hot.accept();
// }
